import { render } from "./routeTable.vue?vue&type=template&id=3289d1a4"
import script from "./routeTable.vue?vue&type=script&lang=js"
export * from "./routeTable.vue?vue&type=script&lang=js"

import "./routeTable.vue?vue&type=style&index=0&id=3289d1a4&lang=scss"
script.render = render

export default script